module.exports = __webpack_public_path__ + "static/img/BK1.eac69e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/BK1.png
// module id = 94Tx
// module chunks = 9